(function () {
  function animateToggle(details, expand) {
    var panel = details.querySelector(".product-accordion__panel");
    if (!panel) return;
    if (details.dataset.animating === "true") return;
    details.dataset.animating = "true";

    panel.style.overflow = "hidden";
    panel.style.transition = "height 260ms ease";

    if (expand) {
      details.open = true;
      panel.style.height = "0px";
      panel.offsetHeight;
      panel.style.height = panel.scrollHeight + "px";

      window.setTimeout(function () {
        panel.style.transition = "";
        panel.style.height = "auto";
        panel.style.overflow = "";
        details.dataset.animating = "false";
      }, 280);
      return;
    }

    panel.style.height = panel.scrollHeight + "px";
    panel.offsetHeight;
    panel.style.height = "0px";

    window.setTimeout(function () {
      panel.style.transition = "";
      panel.style.height = "";
      panel.style.overflow = "";
      details.open = false;
      details.dataset.animating = "false";
    }, 280);
  }

  function initAccordion(accordion) {
    if (!accordion || accordion.dataset.smoothAccordionInit === "true") return;
    accordion.dataset.smoothAccordionInit = "true";

    accordion.querySelectorAll(".product-accordion__item").forEach(function (details) {
      var summary = details.querySelector(".product-accordion__summary");
      var panel = details.querySelector(".product-accordion__panel");
      if (panel) {
        panel.style.height = details.open ? "auto" : "0px";
        panel.style.overflow = details.open ? "" : "hidden";
      }
      if (!summary) return;
      summary.addEventListener("click", function (event) {
        event.preventDefault();
        animateToggle(details, !details.open);
      });
    });
  }

  function initAll() {
    document.querySelectorAll(".product-accordion").forEach(initAccordion);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  requestAnimationFrame(initAll);
  setTimeout(initAll, 120);
})();
